import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, HttpRequestModel } from 'src/app/service/httpservice/http.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  login(email, password, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'auth/login';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = {
      username: email,
      password: password,
    };

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  logout(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'auth/logout';
    this.HttpRequestModel.method = 'POST';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  forgotPassword(email, siteLogo, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'auth/forgot_pasword';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = {
      email: email,
      url: environment.webUrl,
      site_logo: siteLogo,
    };

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  getToken(email, password, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'auth/token';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = {
      username: email,
      password: password,
    };

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  session(showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'auth/session';
    this.HttpRequestModel.method = 'POST';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
